module.exports = __webpack_public_path__ + "static/media/ic_light_close.8447dfe7.png";